import IconLink from '@src/assets/icons/icon-link.png';
import IconUpload from '@src/assets/icons/icon-upload.png';

// Import icon for file upload
import IconFileWord from '@src/assets/icons/icon-file-word.png';
import IconFileText from '@src/assets/icons/icon-file-text.png';
import IconFileImage from '@src/assets/icons/icon-file-image.png';
import IconFilePdf from '@src/assets/icons/icon-file-pdf.png';

// Import icon for upload type for project feature
import InputByWeblink from '@src/assets/images/input-by-weblink.png';
import InputWithText from '@src/assets/images/input-with-text.png';
import InputByTxtPdf from '@src/assets/images/input-by-text-docx-pdf.svg';
import InputBySrt from '@src/assets/images/input-with-srt.png';

// Import icon for project feature
import VideoDubbingIcon from '@src/assets/icons/video-dubbing.svg';
import DubbedIcon from '@src/assets/icons/dubbed.svg';
import DubbedSrtIcon from '@src/assets/icons/dubbed-srt.svg';
import DubbedSliderIcon from '@src/assets/icons/dubbed-slider.svg';
import CreateProjectIcon from '@src/assets/icons/create-project.svg';

// Import icon for web sample crawler
import IconCafeF from '@src/assets/icons/icon-cafe-f.png';
import IconExpress from '@src/assets/icons/icon-express.png';
import IconDanTri from '@src/assets/icons/icon-dan-tri.png';
import IconKenh14 from '@src/assets/icons/icon-kenh-14.png';
import IconBaoMoi from '@src/assets/icons/icon-bao-moi.png';
import IconZing from '@src/assets/icons/icon-zing.png';
import { FEATURE } from './package';

// Maximum file size is 50MB
export const MEGA_BYTE = 50 * 1024 * 1024;

// franc-min language code for Vietnamese (used by PDF/SRT parsers).
export const FRANC_LANG_VN = 'vie';

// PDF is treated as scanned when >5% chars fail the allowed-chars regex.
export const PDF_SCAN_ERROR_THRESHOLD = 5;

export const TYPE_UPLOAD = {
  LINK: 'link',
  FILE: 'file',
  SRT: 'srt',
  PPTX: 'pptx',
  AUDIO: 'audio',
  VIDEO_DUBBING: 'video_dubbing',
};

export const OPTION_UPLOAD_FILE = [
  {
    icon: IconFileWord,
    type: ['docx'],
    isActive: true,
    alt: 'file-word',
    feature: FEATURE.INPUT_DOC,
  },
  {
    icon: IconFileText,
    type: ['txt'],
    isActive: true,
    alt: 'file-text',
    feature: FEATURE.INPUT_TXT,
  },
  {
    icon: IconFileImage,
    type: ['jpg', 'png'],
    isActive: false,
    alt: 'file-image',
    feature: FEATURE.INPUT_IMAGE,
  },
  {
    icon: IconFilePdf,
    type: ['pdf'],
    isActive: true,
    alt: 'file-pdf',
    feature: FEATURE.INPUT_PDF,
  },
];

export const OPTIONS_UPLOAD = [
  {
    icon: IconLink,
    label: 'webLink',
    type: TYPE_UPLOAD.LINK,
    isActive: true,
    formatFile: null,
    feature: FEATURE.INPUT_URL,
    featureDesc: 'inputUrlDesc',
  },
  {
    icon: IconUpload,
    label: 'uploadDocuments',
    type: TYPE_UPLOAD.FILE,
    isActive: false,
    formatFile: null,
  },
  {
    icon: IconFileWord,
    label: 'wordFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: '.docx',
    feature: FEATURE.INPUT_DOC,
    featureDesc: 'inputDocDesc',
  },
  {
    icon: IconFileText,
    label: 'textFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: '.txt',
    feature: FEATURE.INPUT_TXT,
    featureDesc: 'inputTxtDesc',
  },
  {
    icon: IconFileImage,
    label: 'imageFile',
    type: TYPE_UPLOAD.FILE,
    isActive: false,
    formatFile: '.jpg, .png',
    feature: FEATURE.INPUT_IMAGE,
    featureDesc: 'inputImageDesc',
  },
  {
    icon: IconFilePdf,
    label: 'pdfFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: '.pdf',
    feature: FEATURE.INPUT_PDF,
    featureDesc: 'inputPdfDesc',
  },
];

export const LIST_ICON_WEB_SAMPLE = [
  {
    icon: IconCafeF,
    alt: 'CafeF',
  },
  {
    icon: IconExpress,
    alt: 'Express',
  },
  {
    icon: IconDanTri,
    alt: 'Dan Tri',
  },
  {
    icon: IconKenh14,
    alt: 'Kenh14',
  },
  {
    icon: IconBaoMoi,
    alt: 'Bao Moi',
  },
  {
    icon: IconZing,
    alt: 'Zing',
  },
];

// - Vietnamese accented characters
// - Digits (0-9)
// - Whitespace (\s)
// - Punctuation: period (.), comma (,), and other special characters like !, ?, +, ;, ()
export const ALOWED_CHARACTERS_PDF_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^[aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆfFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTuUùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ0-9\s.,!?'"-+;:()\[\]{}%&@#$^*+=<>\\/]+$/;

export const PROJECT_OPTIONS_INPUT = [
  {
    icon: InputWithText,
    label: 'inputWithText',
    type: 'TEXT',
    isActive: true,
    formatFile: null,
  },
  {
    icon: InputBySrt,
    label: 'uploadFileSrt',
    type: TYPE_UPLOAD.SRT,
    isActive: true,
    formatFile: null,
  },
  {
    icon: InputByTxtPdf,
    label: 'inputTxtDocxFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: ['.docx', '.txt', '.pdf'],
  },
  {
    icon: InputByWeblink,
    label: 'inputWebLink',
    type: TYPE_UPLOAD.LINK,
    isActive: true,
    formatFile: null,
  },
  {
    icon: DubbedIcon,
    label: 'uploadVideoAudio',
    type: TYPE_UPLOAD.AUDIO,
    isActive: true,
    isNewFeature: true,
    formatFile: null,
  },
  {
    icon: DubbedSliderIcon,
    label: 'dubbedSlider',
    type: TYPE_UPLOAD.PPTX,
    isActive: true,
    isNewFeature: true,
    formatFile: null,
  },
];

export const PROJECT_OPTIONS_INPUT_NEW = [
  {
    icon: CreateProjectIcon,
    label: 'generateAudio',
    isActive: true,
    subText: 'subCreateProject',
    subOptions: [
      {
        icon: 'CreateProjectIcon',
        label: 'createNewProjectV2',
        type: 'TEXT',
      },
      {
        icon: 'UploadFileIcon',
        label: 'uploadFile',
        type: TYPE_UPLOAD.FILE,
      },
      {
        icon: 'WebLinkIcon',
        label: 'webLink',
        type: TYPE_UPLOAD.LINK,
      },
    ],
  },
  {
    icon: VideoDubbingIcon,
    label: 'dubbedVideo',
    type: TYPE_UPLOAD.VIDEO_DUBBING,
    isActive: true,
    isNewFeature: false,
    subText: 'supportTypeDubbed',
  },
  {
    icon: DubbedSliderIcon,
    label: 'dubbedSlider',
    type: TYPE_UPLOAD.PPTX,
    isActive: true,
    isNewFeature: true,
    subText: 'supportTypeDubbedSlider',
  },
  {
    icon: DubbedSrtIcon,
    label: 'createSrtProject',
    type: TYPE_UPLOAD.AUDIO,
    isActive: true,
    isNewFeature: false,
    subText: 'supportTypeSrt',
  },
];
